export const clearContactLensUrl = '/sg/en/contacts/clear-contactlens';
export const colourContactLensUrl = '/sg/en/contacts/color-contactlens';
export const orthoKContactLensUrl = '/sg/en/contacts/orthok-contactlens';

export const baseImgUrl = 'https://static.lenskart.com/owndays/img/contacts';

export const navCards = [
  {
    title: 'Clear Contact Lens',
    img: `${baseImgUrl}/clear-contact-lens-profile-image.webp`,
    url: clearContactLensUrl,
  },
  {
    title: 'Colour Contact Lens',
    img: `${baseImgUrl}/colour-contact-lens-profile-image.webp`,
    url: colourContactLensUrl,
  },
  {
    title: 'Ortho-k Lens',
    img: `${baseImgUrl}/orthok-k-lens-profile-image.webp`,
    url: orthoKContactLensUrl,
  },
];

export const featuresCL = [
  {
    icon: `${baseImgUrl}/uv-protection-icon.webp`, // UV Protection
    title: 'UV Protection',
    desc: "Our lenses feature an advanced UV-filtering layer that shields your corneas from the sun's most harmful rays (~95% UV-B and 80% UV-A).",
  },
  {
    icon: `${baseImgUrl}/hyaluronic-acid-icon.webp`, // Hyaluronic Acid
    title: 'Hyaluronic Acid',
    desc: 'Each lens is saturated with hyaluronic acid (HA), which helps lock in moisture and reduces friction every time you blink.',
  },
  {
    image: `${baseImgUrl}/why-owndays-contacts-1.webp`, // Image 1
    alt: 'Close up of eye',
  },
  {
    icon: `${baseImgUrl}/high-water-content-icon.webp`, // High Water Content
    title: 'High Water Content',
    desc: 'A higher water percentage allows more oxygen to reach the eye, boosting oxygen permeability (Dk/t) of 30, for clearer, whiter eyes all day.',
  },
  {
    icon: `${baseImgUrl}/ultra-thin-design-icon.webp`, // Ultra-Thin Design
    title: 'Ultra-Thin Design',
    desc: 'Our precision-cut, ultra-thin profile (0.08 mm centre thickness) mimics the natural curvature of the cornea.',
  },
  {
    image: `${baseImgUrl}/why-owndays-contacts-2.webp`, // Image 2
    alt: 'Side view of eye',
  },
  {
    icon: `${baseImgUrl}/singapore-flag-icon.webp`, // Homegrown Excellence
    title: 'Homegrown Excellence',
    desc: 'Designed and manufactured in Singapore under strict quality control standards for superior consistency.',
  },
  {
    icon: `${baseImgUrl}/shape-retention-icon.webp`, // Shape Retention
    title: 'Shape Retention',
    desc: 'A resilient hydrogel matrix lets the lens hold its bowl shape on your fingertip; no more flipping inside-out.',
  },
  {
    image: `${baseImgUrl}/why-owndays-contacts-3.webp`,
    alt: 'Contact lens case',
  },
  {
    icon: `${baseImgUrl}/anti-blue-light-icon.webp`, // Anti Blue Light
    title: 'Anti Blue Light',
    desc: 'An integrated high-energy-visible (HEV) filter blocks up to 15% of blue light in the 400–450 nm range, helping reduce digital eye strain.',
  },
];

export const featuresCLPC = [
  featuresCL[2], // Eye image
  featuresCL[0], // UV Protection
  featuresCL[1], // Hyaluronic Acid
  featuresCL[3], // High Water Content
  featuresCL[4], // Side eye image
  featuresCL[5], // Ultra-Thin Design
  featuresCL[8], // Lens case image
  featuresCL[6], // Homegrown Excellence
  featuresCL[7], // Shape Retention
  featuresCL[9], // Anti Blue Light
];
